import styled from 'styled-components';

export const AtomicGaugeChartWrapper = styled.div`
  height: 100%;
`;
